import React from "react"
import AniLink from 
"gatsby-plugin-transition-link/AniLink";
import Layout from "../components/Layout"

// import SimpleHero from "../components/SimpleHero"
import Banner from "../components/Banner"
import About from '../components/Home/About'
import BriefBio from '../components/Home/BriefBio'
import Services from '../components/Home/Services'
import StyledHero from "../components/StyledHero"
import { graphql } from "gatsby"
import FeaturedProjects from '../components/Home/FeaturedProjects'
export default ({data}) => (

  <Layout>
    
      <Banner
        title="Greg Jones "
      >
        <AniLink fade to="/about" className="btn-white">
          Learn more about Greg
        </AniLink>
        <AniLink fade to="/projects" className="btn-white">
          Case Studies
        </AniLink>
      </Banner>
      <hr className="dividerlines"/>
      <BriefBio/>
      <hr className="dividerlines"/>
      <Services/>
      <hr className="dividerlines"/>
      <FeaturedProjects/>
      <hr className="dividerlines"/>
  </Layout>
)
export const query = graphql`
  query {
    defaultBcg: file(relativePath: { eq: "hustle.jpg" }) {
      childImageSharp {
        fluid(quality: 90, maxWidth: 4160) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
  }
`